import React from 'react';

import useClickOutside from '../../hooks/useClickOutside';
import Modal from '../Modal/Modal';

import css from './ModalDrawer.module.css';
import classNames from 'classnames';

const ModalDrawer = ({ children, header, footer, isOpen, onClose, direction, ...modalProps }) => {
  const wrapperRef = useClickOutside(onClose, isOpen);

  return (
    <Modal
      className={classNames(
        css.modalDrawer,
        direction === 'right' ? css.modalDrawerRight : css.mmodalDrawerLeft
      )}
      contentClassName={css.modalDrawerContent}
      containerClassName={css.modalDrawerContainer}
      closeButtonClassName={css.modalDrawerCloseButton}
      scrollLayerRootClassName={css.modalDrawerScrollLayer}
      isClosedClassName={css.modalDrawerIsClosed}
      isOpenClassName={css.modalDrawerIsOpen}
      usePortal
      withoutLabel
      isOpen={isOpen}
      onClose={onClose}
      {...modalProps}
    >
      <div className={css.modalDrawerContentWrapper} ref={wrapperRef}>
        {header || footer ? (
          <div className={css.modalDrawerContentLayout}>
            <div className={css.modalDrawerContentHeader}>{header}</div>
            <div className={css.modalDrawerContentContent}>{children}</div>
            <div className={css.modalDrawerContentFooter}>{footer}</div>
          </div>
        ) : (
          children
        )}
      </div>
    </Modal>
  );
};

export default ModalDrawer;
